// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__IdEGx","count":"styles_count__0Vk5y"};